module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/tutorial3@2x_324cdc.jpg";